<div id="ChipsSettingPopup" class="modal fade modal-scroll" tabindex="-1" data-replace="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{'ChipsSetting' | translate}}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"> x </button>
      </div>
      <div class="modal-body">
        <div *ngFor="let item of constant.chipsSetting; let i = index" class="p-sm-1 mb-2 row">
          <div class="col-6">
            <div class="row">
              <div class="col-12 col-sm-3 p-0 align-self-center">
                <label>{{'Name' | translate}}</label>
              </div>
              <div class="col-12 col-sm-9  align-self-center">
                <input type="text" class="form-control" [(ngModel)]="item.name">
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12 col-sm-3 p-0 align-self-center">
                <label>{{'Value' | translate}}</label>
              </div>
              <div class="col-12 col-sm-9 align-self-center">
                <input type="number" class="form-control" min="1" [(ngModel)]="item.value"
                  (keypress)="constant.checkNumeric($event)" onpaste="return false;"
                  onkeypress="if(this.value.length==6) return false;if(event.key==='.'){event.preventDefault();}">
              </div>
            </div>
          </div>
          <!-- <div class="mb-1">
            <div class="col-2 text-center fl">
              <label>Name</label>
            </div>
            <div class="col-4 fl">
              <div class="form-group h-25">
                <input type="text" class="form-control" [(ngModel)]="item.name">
              </div>
            </div>

            <div class="col-2 text-center fl">
              <label>Value</label>
            </div>
            <div class="col-4 fl">
              <div class="form-group h-25">
                <input type="number" class="form-control" min="1" [(ngModel)]="item.value"
                  (keypress)="constant.checkNumeric($event)" onpaste="return false;"
                  onkeypress="if(this.value.length==6) return false;if(event.key==='.'){event.preventDefault();}">
              </div>
            </div>
          </div> -->
          <br>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="modal-footer"
        style="text-align: center;background-color: #13334b;box-shadow: 0 -2px 30px rgba(0,0,0,0.75);">
        <button type="button" class="btn btn-md alert-success" aria-hidden="true" (click)="CheckChipsSetting()">{{'Submit' | translate}}
        </button>
        <button type="button" class="btn btn-md alert-danger" data-dismiss="modal" aria-hidden="true"> {{'Cancel' | translate}} </button>
      </div>
    </div>
  </div>
</div>